<template>
    <div id="test" v-if="solution[0]">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">{{solution[0].NAME}}</h1><Breadcrumbs :title="solution[0].NAME"/></div>
        </section>
        <section class="section">
            <div class="container">
                <card class="row px-5 py-3" v-html="solution[0].DETAIL_TEXT" shadow></card>
            </div>
        </section>
        <ContactForm></ContactForm>
    </div>
</template>
<script>
    import ContactForm from "@/components/ContactForm.vue";
    export default {
        components: {
            ContactForm,
        },
        data() {
            return {
                solution: []
            };
        },
        watch: {
            '$route.params.id': function () {
                this.loadInfo()
            }
        },
        created: function () {
            this.loadInfo()
        },
        methods: {
            async loadInfo() {
                let params = new Map();
                params.set('entity', 'solutions');
                params.set('id', this.$route.params.id);

                this.solution = await this.$root.loadContent(params);
                this.$root.title = this.solution[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = this.solution[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            }
        }
    };
</script>
<style>
</style>